import {
  grayColor,
  mlAuto
} from '../../mui-pro/assets/jss/material-kit-pro-react.jsx';

const headerLinksStyle = theme => ({
  list: {
    [theme.breakpoints.up('md')]: {
      WebkitBoxAlign: 'center',
      MsFlexAlign: 'center',
      alignItems: 'center',
      WebkitBoxOrient: 'horizontal',
      WebkitBoxDirection: 'normal',
      MsFlexDirection: 'row',
      flexDirection: 'row'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    marginTop: '0px',
    display: 'flex',
    paddingLeft: '0',
    marginBottom: '0',
    listStyle: 'none',
    padding: '0'
  },
  listItem: {
    float: 'left',
    color: 'inherit',
    position: 'relative',
    display: 'block',
    width: 'auto',
    margin: '0',
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      '& ul': {
        maxHeight: '400px',
        overflow: 'scroll'
      },
      width: '100%',
      '&:not(:last-child)': {
        '&:after': {
          width: 'calc(100% - 30px)',
          content: '""',
          display: 'block',
          height: '1px',
          marginLeft: '15px',
          backgroundColor: grayColor[14]
        }
      }
    }
  },
  navLink: {
    color: 'inherit',
    position: 'relative',
    padding: '0.9375rem',
    fontWeight: '400',
    fontSize: '12px',
    textTransform: 'uppercase',
    lineHeight: '20px',
    textDecoration: 'none',
    margin: '0px',
    display: 'inline-flex',
    '&:hover,&:focus': {
      color: 'inherit'
    },
    '& .fab,& .far,& .fal,& .fas,& .material-icons': {
      position: 'relative',
      top: '2px',
      marginTop: '-4px',
      marginRight: '4px',
      marginBottom: '0px',
      fontSize: '1.25rem'
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 30px)',
      marginLeft: '15px',
      marginBottom: '8px',
      marginTop: '8px',
      textAlign: 'left',
      '& > span:first-child': {
        justifyContent: 'flex-start'
      }
    },
    '& svg': {
      marginRight: '3px',
      width: '24px',
      height: '24px'
    }
  },
  dropdownIcons: {
    width: '24px',
    height: '24px',
    marginRight: '14px',
    opacity: '0.5',
    marginTop: '-4px',
    top: '1px',
    verticalAlign: 'middle',
    fontSize: '24px',
    position: 'relative'
  },
  dropdownLink: {
    '&,&:hover,&:focus': {
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      padding: '0.75rem 1.25rem 0.75rem 0.75rem'
    }
  },
  mlAuto,
  formControl: {
    margin: '0 !important',
    paddingTop: 0
  },
  searchIcon: {
    marginTop: '0px !important',
    width: '20px !important',
    height: '20px !important'
  },
  shiftSearchIcon: {
    marginLeft: '-25px',
    paddingRight: '15px'
  },
  headerButtons: {
    padding: '0 5px'
  },
  inputRootCustomClasses: {
    margin: '0!important'
  },
  inputCustomClasses: {
    width: 'calc(100% - 25px)'
  },
  headerNavButtons: {
    padding: '3px 5px',
    margin: '0 8px',
    '&:hover': {
      color: 'inherit',
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    },
    borderBottom: '3px solid rgba(0, 0, 0, 0)',
    fontSize: 15
  },
  toolbarList: {
    position: 'relative',
    top: '-0.625rem',
    height: 40,
    marginRight: 10
  },
  menuList: {
    position: 'relative',
    top: '0.625rem'
  }
});

export default headerLinksStyle;
